import _ from 'lodash';
import accounting from 'rgs-accounting';

const moneyRepr = _.partial(accounting.formatMoney, _, '');
const moneyReprExtend = { repr: moneyRepr };

const moneyDotSeparatedRepr = _.partial(accounting.formatMoney, _, '', 2, ' ', '.');
const moneyDotSeparatedReprExtend = { repr: moneyDotSeparatedRepr };

const moneyShortRepr = _.partial(accounting.formatMoney, _, '', 0);
const moneyShortReprExtend = { repr: moneyShortRepr };

export {
	moneyRepr,
	moneyDotSeparatedRepr,
	moneyShortRepr,
	moneyReprExtend,
	moneyDotSeparatedReprExtend,
	moneyShortReprExtend,
};
